/**
 * @description  Dydu reword type
 * see extraParameters at https://app1.earth.doyoudreamup.com/doc/fr_FR/Topics/Others/API_reference/Query_dialog_engine.html?hl=reword
 */

export default Object.freeze({
  RW_AUTO: 'reword_auto',
  RD: 'redirection',
  RD_NEW_PAGE: 'redirection_newpage',
  RD_JAVASCRIPT: 'redirection_javascript',
  RD_KNOWLEDGE: 'redirection_knowledge',
  RD_SPACE: 'redirection_consultation_space',
  RD_PERSONNALITY: 'redirection_personnality',
  BEFORE_CLOSE_DIALOG: 'before_close_dialog',
  RW_TEASER: 'reword_teaser',
  EXPORTABLE_FAQ: 'exportable_faq',
  RW_FEEDBACK: 'reword_feedback',
})
